(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-support-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oc-support-contact')) {
    customElements.define('oc-support-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.status = this.querySelector('[role="status"]');
        this.submit = this.querySelector('[type="submit"]');
        this.retry = this.querySelector('.oc-support__retry');
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this.send(); });
        this.retry.addEventListener('click', () => this.upload());
      }
      tell(text) { this.status.textContent = text; this.status.focus(); }
      async request(path, options) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(this.dataset.endpoint + path, { ...options, signal: controller.signal, credentials: 'omit' });
          const body = await response.json();
          if (!response.ok) { const error = new Error('request_failed'); error.rejected = [400, 413, 415, 422].includes(response.status); throw error; }
          return body;
        } finally { clearTimeout(timer); }
      }
      async send() {
        if (this.busy || this.accepted) return;
        this.busy = true; this.submit.disabled = true;
        try {
        if (!this.snapshot) {
          if (!this.form.reportValidity()) return;
          const data = new FormData(this.form);
          this.file = this.form.elements.file.files[0];
          if (this.file && (this.file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp', 'application/pdf'].includes(this.file.type))) {
            this.tell('Please choose one JPEG, PNG, WebP or PDF up to 5 MB. Your message has not been sent.'); return;
          }
          const payload = { category: data.get('category'), email: data.get('email').trim(), order_reference: data.get('order_reference').trim(), body: data.get('body').trim(), website: data.get('website'), has_attachments: Boolean(this.file) };
          if (!payload.body) { this.tell('Please enter a message.'); return; }
          const signature = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(payload))))).map(x => x.toString(16).padStart(2, '0')).join('');
          let saved;
          try { saved = JSON.parse(sessionStorage.getItem('oc-support-request')); } catch { saved = null; }
          const key = saved?.signature === signature ? saved.key : crypto.randomUUID();
          try { sessionStorage.setItem('oc-support-request', JSON.stringify({ key, signature })); } catch { /* In-memory retry remains available. */ }
          this.snapshot = { ...payload, key };
        }
        this.busy = true; this.submit.disabled = true; this.form.querySelector('fieldset').disabled = true;
        this.tell('Sending your request…');
          const receipt = await this.request('', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.snapshot) });
          if (!receipt.accepted || !/^OC-\d+$/.test(receipt.reference)) throw new Error('receipt_missing');
          this.accepted = receipt.reference; this.submit.hidden = true;
          this.tell(`Your request ${this.accepted} has been received. We will reply by email. Please reply to that email if you need to add anything.`);
          if (this.file) await this.upload();
        } catch (error) {
          if (error.rejected) {
            this.snapshot = null; this.form.querySelector('fieldset').disabled = false;
            try { sessionStorage.removeItem('oc-support-request'); } catch { /* Optional retry storage. */ }
            this.tell('Your request was not accepted. Please check your details and edit the message, or email service@old-crowns.com.'); this.submit.textContent = 'Send request'; return;
          }
          this.tell('We could not confirm receipt yet. Your message is kept here. Press “Retry same request” to check again without creating a duplicate. You can also email service@old-crowns.com.');
          this.submit.textContent = 'Retry same request'; this.submit.disabled = false;
        } finally { this.busy = false; if (!this.accepted) this.submit.disabled = false; }
      }
      async upload() {
        if (!this.accepted || !this.file || this.uploading) return;
        this.uploading = true; this.retry.disabled = true;
        try {
          const data = new FormData(); data.append('file', this.file);
          await this.request('/attachments', { method: 'POST', headers: { 'X-Support-Submission': this.snapshot.key }, body: data });
          this.retry.hidden = true;
          this.tell(`Your request ${this.accepted} and attachment have been received. We will reply by email.`);
        } catch {
          this.retry.hidden = false;
          this.tell(`Your request ${this.accepted} has been received, but we could not confirm the attachment upload. Retry the upload, or send the file by email and include ${this.accepted}.`);
        } finally { this.uploading = false; this.retry.disabled = false; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
